"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledDividerWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 20px 0;\n"])));
var Text = (0, _styledComponents.default)(_fonts.P)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0 16px !important;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var StyledDivider = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 0;\n  border-top: 1px solid ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryShade2;
});
var Divider = function Divider(props) {
  return /*#__PURE__*/_react.default.createElement(StyledDividerWrapper, null, /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(Text, null, props.text), /*#__PURE__*/_react.default.createElement(StyledDivider, null));
};
exports.Divider = Divider;